import { FuelType } from '@/src/types/Account';

export const getOtherFuelType = (fuel: FuelType): FuelType =>
  fuel === 'electricity' ? 'gas' : 'electricity';
